import en_US from "./en_US/messages.json"
import validatorUS from "./en_US/validator.json"
import sr from "./sr/messages.json"
import validatorSR from "./sr/validator.json"
import onboardingUS from "./en_US/onboarding.json"
import onboardingSR from "./sr/onboarding.json"

export default {
    en_US: {
        ...en_US,
        ...validatorUS,
        ...onboardingUS,
    },
    sr: {
        ...sr,
        ...validatorSR,
        ...onboardingSR,
    }
}